import gql from 'graphql-tag';

export const GET_CUSTOM_STAGES_QUERY = gql`
  query GetAllStagesQuery($programId: Int!) {
    getAllStages(programId: $programId) {
      id
      name
      programId
      stageTemplateId
      showInteraction
      createdAt
      updatedAt
      stageTemplate {
        id
        name
        description
      }
      statuses {
        id
        name
        priority
        metadata {
          isFinalStatus
          enableNotification
        }
      }
      tasks {
        id
        name
        ctaLabel
        creatorAccess
        fieldSchemas {
          id
          name
          type
          description
          metaData
          isMemberLevel
          isProgramLevel
        }
      }
      taskSettings {
        initialStatuses {
          id
          name
        }
        finalStatus {
          id
          name
        }
      }
    }
  }
`;

export const GET_CUSTOM_STAGE_STATUS_COUNTS = gql`
  query GetCustomStageStatusCounts($stageId: Int!) {
    getCountsForCustomStageStatuses(stageId: $stageId) {
      statusId
      statusName
      count
    }
  }
`;

export const GET_CUSTOM_STAGE_MEMBERS = gql`
  query GetCustomStageMembers($stageId: Int!, $statusId: Int) {
    getCustomStageMembers(stageId: $stageId, statusId: $statusId) {
      id
      memberId
      stageId
      currentStatusId
      previousStatusId
      currentStageStatus {
        id
        name
      }
      previousStageStatus {
        id
        name
      }
    }
  }
`;
